import api from '../../plugins/api';

const addLeadComment = ({ leadId, comment }) => {
  return api.post('/api/crm/leads/addLeadComment', { leadId, comment });
};

export default addLeadComment;
